"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppHeight = void 0;
var react_1 = require("react");
var useAppHeight = function () {
    var appHeight = function () {
        var doc = document.documentElement;
        doc.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('resize', appHeight);
        appHeight();
        return function () {
            window.removeEventListener('resize', appHeight);
        };
    }, []);
};
exports.useAppHeight = useAppHeight;
